import Toasts from './Toasts';
import { toastsStore } from './store/toasts';
import { IToastProps, ToastDuration } from './types/toasts';

export default Toasts;
export { toastsStore, ToastDuration, type IToastProps };
